import React, { useEffect } from 'react'
import { Switch, Button, Popover, Tooltip } from 'antd'
import isObject from 'lodash/isObject'
import { useIntl } from 'react-intl'
import { TableOutlined } from '@ant-design/icons'

const parseDataIndex = path => {
  if (typeof path === 'string') return path
  return path.join('.')
}

const ColumnSelector = props => {
  const { columns, onColumnSelectionChanged, settingsKey, style } = props

  const intl = useIntl()

  useEffect(() => {
    // Check for settingsKey and localStorage settings
    // Apply once and send to parent <DataTable /> state
    if (settingsKey) {
      const tableSettings = JSON.parse(localStorage.getItem(`app.datatable.${settingsKey}`))

      if (tableSettings) {
        const columnSelectorSettings = tableSettings.columnSelector

        if (columnSelectorSettings && isObject(columnSelectorSettings)) {
          const result = {}
          let newColumns = [...columns]

          newColumns = newColumns.map(col => {
            const keyOrDataIndex = col.dataIndex || col.key
            if (columnSelectorSettings[parseDataIndex(keyOrDataIndex)]) {
              col.hidden = columnSelectorSettings[parseDataIndex(keyOrDataIndex)]
            }

            return col
          })

          newColumns.forEach(el => {
            const keyOrDataIndex = el.dataIndex || el.key
            result[parseDataIndex(keyOrDataIndex)] = el.hidden
          })

          onColumnSelectionChanged(result)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnChange = (checked, event, dataIndex) => {
    const result = {}

    columns.forEach(el => {
      const keyOrDataIndex = el.dataIndex || el.key
      result[parseDataIndex(keyOrDataIndex)] = el.hidden
    })

    result[parseDataIndex(dataIndex)] = !checked

    if (settingsKey) {
      localStorage.setItem(
        `app.datatable.${settingsKey}`,
        JSON.stringify({
          columnSelector: { ...result },
        }),
      )
    }

    onColumnSelectionChanged(result)
  }

  // Filter columns based on 'excludeFromColumnSelector' prop
  const newColumns = columns.filter(el => el.excludeFromColumnSelector !== true)

  const settings = (
    <div style={{ width: 200 }}>
      {newColumns.length > 0
        ? newColumns.map(el => {
            const keyOrDataIndex = el.dataIndex || el.key

            return (
              <div key={parseDataIndex(keyOrDataIndex)} style={{ marginBottom: '.5rem' }}>
                <Switch style={{ marginRight: '1rem' }} checked={!el.hidden} onChange={(checked, event) => handleOnChange(checked, event, parseDataIndex(keyOrDataIndex))} />
                {el.title}
              </div>
            )
          })
        : 'No columns selected'}
    </div>
  )

  return (
    <Popover placement="bottomRight" trigger="click" content={settings}>
      <Tooltip placement="top" title={intl.formatMessage({ id: 'datatable.tooltips.columns' })}>
        <Button style={style} icon={<TableOutlined />} />
      </Tooltip>
    </Popover>
  )
}

export default ColumnSelector
